import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import { UserRest } from '../../../../core/services/core.user.rest.service';
import { UserService } from '../../../../core/services/core.user.service';
import { TrackerService } from '../../services/tracker.service';
import { TrackeritemService } from '../../services/trackeritem.service';
import { GfTranslateService } from '../../../../core/services/core.translate.service';
import { SiteConfigService } from '../../../../core/services/core.site-config.service';
import { buildTrackerMacroContext, expandTrackerMacros } from '../../services/tracker.macro.functions';

@Component({
  selector: 'trackeritem-add-modal',
  template: require('./trackeritem.add.modal.component.html')
})
export class TrackeritemAddModalComponent implements OnInit, AfterViewInit {
  @Input() tracker: any;
  @Input() trackers: any;
  @Input() project: any;
  @Input() params: any;
  @Input() customTrackeritem: any;
  @Input() extraData: any;

  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCreate: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('autoFocusInput', { static: false }) autoFocusInput!: ElementRef;

  assignees: any[] = [];
  defaults: any = {};
  tags: any[] = [];
  errors: any = {
    summary: {
      hasError: false
    }
  };
  isLoaded: boolean = false;
  mode: string = 'add';
  allowUpdate: boolean = true;
  allowAssignments: boolean = true;
  priorityOptions: any = {};
  title: string = '';
  subtitle: string = '';
  footerMessage: string = '';
  hideApplyAssignees: boolean = true;
  submitText: any = false;
  close: any;
  callback: any;
  trackeritem: any = {};
  acls: any = {
    canAssign: true
  };

  constructor(
    private userRest: UserRest,
    private userService: UserService,
    private trackerService: TrackerService,
    private trackeritemService: TrackeritemService,
    private translateService: GfTranslateService,
    private siteConfigService: SiteConfigService,
  ) {}

  /**
   * Expands the project-scoped macros in the tracker's submit instructions.
   * This modal has no router injected, so %PROJECT_URL% / %TRACKER_URL% are
   * left unexpanded here; the full-screen add form resolves them.
   */
  private expandInstructions(text: string): string {
    const siteName = _.get(this.siteConfigService.getSiteConfig(), 'siteName', '');
    return expandTrackerMacros(text, buildTrackerMacroContext(this.tracker, siteName));
  }


  ngOnInit(): void {
    this.defaults = this.params?.defaults || {};
    this.title = this.params?.title || '';
    this.subtitle = this.params?.subtitle || '';
    this.footerMessage = this.params?.footerMessage || '';

    this.priorityOptions = {
      id: 'priority',
      fieldName: this.translateService.translate('Priority'),
      fieldElements: this.trackerService.fields.builtIn.priority.getList()
    };


    // Mint the temp ref id the details editor uploads images against, so the
    // save below can hand it to the backend for re-association.
    this.trackeritemService.generateTempTid();

    this.setSubmitInstructions();
    this.initTrackerItem();
  }

  ngAfterViewInit(): void  {

  }

  closeModal(): void {
    this.onClose.emit({});
  }

  submitTrackeritem(saveAndNew: boolean = false): void {
    if (!this.trackeritem.tracker.id) {
      this.errors = {
        tracker: {
          error: 'Required field',
          hasError: true
        },
        summary: {
          hasError: false
        }
      };
      return;
    }

    this.trackeritemService.save(this.trackeritem, {
      stopRedirection: true,
      tmpRefId: this.trackeritemService.getTempTid()
    })
    .then((response: any) => {
      if (!_.isEmpty(response) && _.has(response, 'id')) {
        return this.trackeritemService.tagsSave(response.id, this.tags)
          .then(() => response);
      }
      return response;
    })
    .then((response: any) => {
      this.onCreate.emit({
        trackeritem: response,
        params: this.params,
        keepOpen: saveAndNew
      });

      if (saveAndNew) {
        // Reset only summary, details and errors
        this.trackeritem.summary = '';
        this.trackeritem.details = '';
        this.errors = {};
        // Fresh temp ref id so the next item's images are not filed under the
        // one just consumed by the save above.
        this.trackeritemService.generateTempTid();
      } else {
        this.closeModal();
      }

      return null;
    })
    .catch((error) => {
      this.errors = error;
      return null;
    });

  }

  changeTracker(tracker_id: any): void {
    const sessionUser = this.userService.session.getUser();
    if (sessionUser && _.has(this.project, 'id') && sessionUser.id > 100 && !_.isEmpty(this.params) && this.params.section) {
      this.userRest.saveUserPreference(sessionUser.unixName, 'addti_' +  this.project.id + '_' + this.params.section, tracker_id);
    }

    this.isLoaded = false;
    this.trackeritemService.loadTrackerAndBlankModel(tracker_id)
      .then(({ tracker, trackeritem }) => {
        this.tracker = tracker;
        this.setSubmitInstructions();
        this.trackeritem = trackeritem;
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.isLoaded = true;
      });
  }

  private setSubmitInstructions(): void {
    if (this.tracker?.submitInstructions ?? null) {
      this.submitText = {
        type: 'markdown',
        title: this.tracker.trackerName,
        glyph: 'glyphicon-info-sign',
        content: this.expandInstructions(this.tracker.submitInstructions)
      };
    } else {
      this.submitText = false;
    }
  }

  private loadMembers(): Promise<any> {
    return this.trackerService.loadAssignees(this.tracker.id)
    .then((response: any) => {
        if (!_.isEmpty(response) && _.has(response, 'items')) {
          this.assignees = response.items;
        }
      }).catch((error: any) => {
        console.error(error);
        return null;
      });
  }

  private getFirstTrackerFromList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.tracker = this.tracker || (!_.isEmpty(this.trackers) ? this.trackers[0] : null);
      const trackerId = _.has(this.tracker, 'tracker_id') ? this.tracker.tracker_id : this.tracker.id;
      if (1==1 || !_.isEmpty(this.tracker) && !_.has(this.tracker, 'fields')) {
        this.loadTracker(trackerId).then(resolve).catch(reject);
      } else {
        reject('No tracker available');
      }
    });
  }
  
  private loadTracker(trackerId: any): Promise<any> {
    return this.trackerService.load(trackerId)
      .then((data: any) => {
        if (!data) throw new Error('Tracker data is undefined');
        this.tracker = data;
        this.setSubmitInstructions();
        return data;
      })
      .catch((error) => {
        console.error('Error loading tracker:', error);
        return Promise.reject(error);
      });
  }
  
  private setTracker(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (_.isEmpty(this.tracker) && _.has(this.project, 'id') &&
          this.userService.session.getUserId() > 100 && !_.isEmpty(this.params) &&
          this.params.section)
      {
        this.userRest.getUserPreference(this.userService.session.getUnixName(), 'addti_' + this.project.id + '_' + this.params.section)
          .then((response: any) => {
            if (!_.isEmpty(response) && _.has(response, 'preferenceValue')) {
              this.loadTracker(response.preferenceValue).then(resolve).catch(reject);
            } else {
              this.getFirstTrackerFromList().then(resolve).catch(reject);
            }
          })
          .catch((error) => {
            console.error('Error getting user preference:', error);
            this.getFirstTrackerFromList().then(resolve).catch(reject);
          });
      } else {
        this.getFirstTrackerFromList().then(resolve).catch(reject);
      }
    });
  }
  
  private initTrackerItem(): void {
    if (this.customTrackeritem) {
      const customTrackeritem = this.customTrackeritem(this.extraData, this.trackeritem);
      Object.assign(this.trackeritem, customTrackeritem);
    }

    Promise.all([this.loadMembers(), this.setTracker()])
      .then(() => {
        this.isLoaded = true;

        this.trackeritem = this.trackeritemService.getBlankModel(this.tracker, null, this.defaults);

        this.trackeritem.summary = '';
        this.trackeritem.details = '';
        this.trackeritem.rel = {
          assignees: []
        };

        if (_.has(this.tracker.fields, 'sprint')) {
          this.tracker.fields.sprint.fieldElements = this.trackerService.fields.getSprintsGroupedByStatus(this.tracker.fields.sprint);
        }

        for (const i in this.tracker.fields) {
          if (this.tracker.fields[i].fieldType === 8) {
            this.tracker.fields[i].fieldElements = this.trackerService.fields.getReleasesGroupedByStatus(this.tracker.fields[i]);
            this.trackeritemService.setDefaultValueForReleaseField(this.trackeritem, this.tracker.fields[i]);
          }
        }

        this.trackeritemService.setTrackeritem(this.trackeritem);
      })
      .catch(error => {
        console.error('Error in loading members or setting tracker:', error);
      });
  }

  tagsUpdated($event) {
    this.trackeritem.tags = $event;
  }

  setAssignees(assignees: any): void {
    _.set(this.trackeritem, 'rel.assignees', assignees);
  }
}


